import { RiBuilding4Fill, RiBuilding2Fill, RiMiniProgramLine } from "react-icons/ri";
import { FaUsers, FaRegListAlt, FaChalkboardTeacher, FaRegCalendar } from "react-icons/fa";
import { ImUsers } from "react-icons/im";
import { RiRecycleFill } from "react-icons/ri";
import { CgTemplate } from "react-icons/cg";
import { RiSecurePaymentFill } from "react-icons/ri";
import { AiFillDollarCircle } from "react-icons/ai";
import { GiModernCity } from "react-icons/gi";
import { AiOutlineMail } from "react-icons/ai";
import { IoIosNotificationsOutline } from "react-icons/io";
import { MdCable, MdPayment, MdSchedule, MdViewList, MdAutoAwesome } from "react-icons/md";
import { FcCalendar, FcDataConfiguration, FcInvite } from "react-icons/fc";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { MdConnectedTv, MdFeedback } from "react-icons/md";
import { BsFillChatRightTextFill } from "react-icons/bs"
import { TbReportAnalytics, TbReportSearch, TbTemplate, TbTruckDelivery } from "react-icons/tb"
import { SiAzurepipelines } from "react-icons/si"
import TruckLogo from './images/better-truck-logo.svg'
import { MdPaid } from "react-icons/md";
import { ADHOC } from "../src/constants/variables/index";
import { ROLE_PERMISSIONS, checkPermission } from "./auth/permissions";

const RootAndAdmin = ["root", "admin", "new_admin"];
const RootOnly = ["root", "new_admin"];
const BookkeeperOnly = ["bookkeeper"];
const RootAdnBookkeeper = [...RootAndAdmin, "bookkeeper"];
const RootAdminAndBookkeeper = [...RootAndAdmin, ...BookkeeperOnly]
const DriverCommunicationRoles = [...RootAndAdmin, "metro_manager"];
const rolesWith = (permission) =>
  Object.keys(ROLE_PERMISSIONS).filter((role) => checkPermission(role, permission));
const OperationalManagers = rolesWith("drivers.view");
const ShiftRoles = rolesWith("shifts.view");
const SchedulingRoles = rolesWith("shifts.schedule");
const PaymentRoles = rolesWith("payments.view");
const AdhocPaymentRoles = [...new Set([
  ...rolesWith("payments.enter"),
  ...rolesWith("payments.approve"),
  ...rolesWith("payments.release"),
])];
const BonusCampaignRoles = rolesWith("bonus.create");
const BonusReportRoles = rolesWith("bonus.reports");
const BonusDisbursementRoles = rolesWith("bonus.disburse");
const BonusRoles = [...new Set([...BonusCampaignRoles, ...BonusReportRoles, ...BonusDisbursementRoles])];
const HubViewRoles = rolesWith("hubs.view");
const MetroViewRoles = rolesWith("metros.view");
const UserViewRoles = rolesWith("users.view");
const BetterTrucksRoles = [...new Set([...HubViewRoles, ...MetroViewRoles, ...UserViewRoles])];

export const routesList = [
  {
    path: "Bettertrucks",
    name: "Better Trucks",
    icon: TruckLogo,
    role: BetterTrucksRoles,
    subPathArray: ['/hubs', '/metros', '/company', '/users'],
    subRoutes: [
      {
        path: "hubs",
        name: "Hubs",
        icon: <RiBuilding4Fill />,
        role: HubViewRoles
      },
      {
        path: "metros",
        name: "Metros",
        icon: <GiModernCity />,
        role: MetroViewRoles
      },
      { path: "company", name: 'Company', icon: <RiBuilding2Fill />, role: RootAndAdmin },
      {
        path: "users",
        name: 'Users',
        icon: <ImUsers />,
        currentUser: true,
        role: UserViewRoles,
      },
    ],
  },
  
  { path: "drivers", icon: <FaUsers />, role: OperationalManagers },
  
  { path: "prospectDrivers", name: "Prospect Drivers", icon: <FcInvite />, role: RootOnly },

  {
    name: 'Operators',
    path: "operator",
    icon: <MdConnectedTv />,
    role: RootAndAdmin,
  },
  {
    path: "shiftsGroup",
    name: "Shifts",
    icon: <TbTruckDelivery />,
    role: ShiftRoles,
    subPathArray: ['/shifts', '/scheduling', '/shiftstemplate'],
    subRoutes: [
      {
        path: "shifts",
        name: "All Shifts",
        icon: <MdViewList />,
        role: ShiftRoles,
      },
      {
        path: "scheduling",
        name: "Scheduling Assistant",
        icon: <MdAutoAwesome />,
        role: SchedulingRoles,
      },
      {
        path: "shiftstemplate",
        icon: <TbTemplate />,
        name: "Shifts Template",
        role: RootAndAdmin,
      },
    ],
  },
  {
    path: "deposit",
    icon: <CgTemplate />,
    currentUser: true,
    role: BookkeeperOnly,
  },
  {
    path: "communication",
    name: "Driver communication",
    icon: <BsFillChatRightTextFill />,
    role: DriverCommunicationRoles,
    subPathArray: ['/feedback', '/emails', '/notifications', '/drivercoaching'],
    subRoutes: [
      { path: "drivercoaching", icon: <FaChalkboardTeacher />, role: DriverCommunicationRoles, name: "Driver Coaching" },
      { path: "feedback", icon: <MdFeedback />, role: DriverCommunicationRoles },
      {
        path: "emails",
        icon: <AiOutlineMail />,
        role: RootAndAdmin,
      },
      {
        path: "notifications",
        icon: <IoIosNotificationsOutline />,
        role: RootAndAdmin,
      }
    ],
  },
  {
    path: "pay",
    name: "Payments",
    icon: <MdPayment />,
    role: PaymentRoles,
    subPathArray: ['/payments', '/paymentsCalendar', '/adhocpayment'],
    subRoutes: [
      {
        path: "payments",
        icon: <RiSecurePaymentFill />,
        role: PaymentRoles,
      },
      {
        path: "paymentsCalendar",
        icon: <FaRegCalendar />,
        role: rolesWith("payments.calendar"),
        name: 'Payment Calendar'
      },
      {
        path: "adhocpayment",
        icon: <RiRecycleFill />,
        name: ADHOC,
        role: AdhocPaymentRoles,
      },
    ],
  },

  {
    path: "reports",
    name: "Reports",
    icon: <TbReportAnalytics />,
    role: RootAdminAndBookkeeper,
    subPathArray: ['/schedulers/pipeline_drivers', '/piplinestage', '/reports/drivers-earning', '/reports/transactions'],
    subRoutes: [
      {
        path: "schedulers",
        name: "Pipeline",
        icon: <SiAzurepipelines />,
        role: RootAndAdmin,
      },
      {
        path: "piplinestage",
        icon: <MdCable />,
        name: "Driver onboarding pipeline",
        role: RootAndAdmin,
      },
      {
        path: "/reports/drivers-earning",
        name: "Drivers Earning",
        icon: <AiFillDollarCircle />,
        role: RootAdnBookkeeper,
      },
      {
        path: "/reports/transactions",
        name: "Transactions",
        icon: <CompareArrowsIcon />,
        role: RootAdnBookkeeper,
      },
    ],
  },
  {
    path: "bonusCampaign",
    name: "Bonus",
    role: BonusRoles,
    icon: <RiMiniProgramLine />,
    subPathArray: ['/bonusCampaign', '/bonusCampaign/disbursement', '/bonusCampaign/report'],
    subRoutes: [
      {
        path: "bonusCampaign",
        name: "Campaign",
        icon: <FcDataConfiguration />,
        role: BonusCampaignRoles,
      },
      {
        path: "bonusCampaign/report",
        name: "Report",
        icon: <TbReportSearch />,
        role: BonusReportRoles,
      },
      {
        path: "bonusCampaign/disbursement",
        name: "Disbursement",
        icon: <MdPaid />,
        role: BonusDisbursementRoles,
      }
    ],
  }
]